$(document).ready(function() {
	let maps = document.querySelectorAll("[google-map]");

	if (maps.length) {
		const script = document.createElement("script");
		script.src = "https://maps.googleapis.com/maps/api/js?key=" + window.google_api_key; //set as window variable
		document.head.appendChild(script);

		script.onload = function() {
			for (let i = 0; i < maps.length; i++) {
				let map = maps[i];
				let coords = {lat: null, lng: null};
				let icon_image = map.dataset.icon;

				if (typeof icon_image == "undefined" || icon_image.length <= 0) {
					icon_image = null;
				}

				if (typeof map.dataset.lat !== 'undefined' && typeof map.dataset.lng !== 'undefined') {
					coords = {
						lat: parseFloat(map.dataset.lat),
						lng: parseFloat(map.dataset.lng)
					};
					let currentMap = new google.maps.Map(map, {
						zoom: 14,
						center: coords
					});
	
					let icon = {
						url: icon_image,
						scaledSize: new google.maps.Size(50, 50)
					};
	
					let marker = new google.maps.Marker({
						position: coords,
						icon: icon,
						map: currentMap
					});
				}
			};
		};
    }
});